import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/promotion/pramotionClose.png'


const _hoisted_1 = { class: "popupContainer" }

import { computed, PropType } from 'vue'
import PromotionCard from './components/promotionCardNew.vue'
import { useI18n } from 'vue-i18n';
import { useUserStore } from '@/stores/user';
import { activityCount, PromotionData } from '@/view/promotion/supporrtScript';

export default /*@__PURE__*/_defineComponent({
  __name: 'promotionPopup',
  props: {
    dataSet: {
        type: Object as PropType<PromotionData>,
        required: true
    }
},
  emits: ['open', 'close', "openAgentPopup", "openPWAPopup", 'update:show'],
  setup(__props, { emit: __emit }) {

const userStore = useUserStore()
const { t } = useI18n();

const props = __props

const show = computed({
    get: () => props.dataSet.show,
    set: (val) => emits('update:show', val)
})

const emits = __emit
const open = () => {
    emits('open')
}
const close = () => {
    emits('close')
}
const openAgentPopup = () => {
    emits("openAgentPopup")
}

const openPWAPopup = () => {
    emits("openPWAPopup")
}
const isShowCard = (name: string) => {
    if (name === 'pwa_reward') {
        const hasPwaInfo = userStore.PWAConvertData
        if (hasPwaInfo) {
            return true
        } else {
            return false
        }

    } else {
        return true
    }
}

return (_ctx: any,_cache: any) => {
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_row = _resolveComponent("van-row")!
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createBlock(_component_van_popup, {
    show: show.value,
    "onUpdate:show": _cache[0] || (_cache[0] = ($event: any) => ((show).value = $event)),
    position: "bottom",
    "overlay-style": { overflow: 'hidden' },
    style: {
        minWidth: '100%',
        minHeight: '100%',
        color: '#fff',

    }
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_van_row, { class: "header_container" }, {
          default: _withCtx(() => [
            _createVNode(_component_van_col, {
              span: "21",
              class: "header_col"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('common.promotion')), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_van_col, {
              span: "3",
              class: "header_col"
            }, {
              default: _withCtx(() => [
                _createElementVNode("img", {
                  src: _imports_0,
                  alt: "",
                  onClick: close
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _cache[1] || (_cache[1] = _createElementVNode("div", { class: "card_list" }, null, -1)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.dataSet?.promotionList, (item, index) => {
          return (_openBlock(), _createElementBlock("div", { key: index }, [
            (isShowCard(item.name))
              ? (_openBlock(), _createBlock(PromotionCard, {
                  key: 0,
                  itemData: item,
                  "un-claimed-count": _unref(activityCount)(_unref(userStore).unreadActivityMsgList, item?.id),
                  onOpenAgentPopup: openAgentPopup,
                  onGoToHome: close,
                  onOpenPWA: openPWAPopup
                }, null, 8, ["itemData", "un-claimed-count"]))
              : _createCommentVNode("", true)
          ]))
        }), 128))
      ])
    ]),
    _: 1
  }, 8, ["show"]))
}
}

})